module.exports = __webpack_public_path__ + "img/QR+admin.5474d158.png";